const maxLength = max => value =>
  value && value.length > max ? `Maximo ${max} caracteres` : undefined;

const minLength = min => value =>
  value && value.length < min ? `Minimo ${min} caracteres` : undefined;

export const required = value => (value ? undefined : 'Requerido');

export const number = value =>
  value && isNaN(Number(value)) ? 'Solo numeros' : undefined;

export const minValue = min => value =>
  value && value < min ? `Minimo ${min}` : undefined;

export const noObject = value =>
  value == null || typeof value != 'object'
    ? undefined
    : 'Seleccione una opcion valida o cree una';

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Direccion de email invalida'
    : undefined;

export const maxLength50 = maxLength(50);
export const maxLength40 = maxLength(40);
export const maxLength200 = maxLength(200);
export const minLength2 = minLength(2);
export const minLength3 = minLength(3);
export const minLength4 = minLength(4);
export const minLength7 = minLength(7);
export const maxLength8 = maxLength(8);
export const maxLength12 = maxLength(12);
export const maxLength80 = maxLength(80);



// WEBPACK FOOTER //
// src/modules/forms/validations.js